module.exports = __webpack_public_path__ + "static/media/c6bannerModulE_small.621d5596.jpg";